import './index.scss'

class Distributors {
    constructor(el) {
        this.$el = el

        // console.log('Text::constructor')
    }
    init() {
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-distributors') ].forEach($block => {
        $block.expandygg = new Distributors($block)
    })
}, {capture: false, passive: true, once: true} || false)